var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Block, SylPlugin } from '@syllepsis/adapter';
import { NODE_NAME } from './const';
import { createCellAttrs, getCellAttrs, setCellAttrs } from './utils';
var createTableCellPlugin = function (props) {
    var TableCellItem = /** @class */ (function (_super) {
        __extends(TableCellItem, _super);
        function TableCellItem() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.name = NODE_NAME.TABLE_CELL;
            _this.content = 'block+';
            _this.attrs = createCellAttrs(props.defaultCellWidth, props.cellAttributes);
            _this.tableRole = 'cell';
            _this.isolating = true;
            _this.parseDOM = [
                {
                    tag: 'td',
                    getAttrs: function (dom) { return getCellAttrs(dom, props.cellAttributes); }
                },
                {
                    tag: 'th',
                    priority: 20,
                    getAttrs: function (dom) { return getCellAttrs(dom, props.cellAttributes); }
                }
            ];
            _this.toDOM = function (node) { return ['td', setCellAttrs(node, props.cellAttributes), 0]; };
            return _this;
        }
        return TableCellItem;
    }(Block));
    return /** @class */ (function (_super) {
        __extends(TableCellPlugin, _super);
        function TableCellPlugin() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.Schema = TableCellItem;
            return _this;
        }
        return TableCellPlugin;
    }(SylPlugin));
};
export { createTableCellPlugin };
//# sourceMappingURL=table-cell.js.map